// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-228","move":"move-8c9","overlay":"overlay-a39"};